import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';
import { ApolloLink } from 'apollo-link';
import fetch from 'unfetch';
import {
  akamaiCaching,
  hasHeaders,
  isCacheableHeader,
  queryClassificationHeader,
  queryDebug,
  sourceHeader,
  trackGraphQLErrors,
  uid,
  geoLocationHeader,
} from '@express-labs/raven-middleware';

const ignoreList = [];

const httpLink = new HttpLink({
  credentials: 'same-origin',
  // This file is also used in jest tests where global.fetch is defined
  // eslint-disable-next-line no-undef
  fetch: global.fetch || fetch,
  uri: '/graphql',
});

const middlewares = [
  hasHeaders,
  akamaiCaching,
  queryClassificationHeader,
  sourceHeader('app_express.com'),
  isCacheableHeader,
  uid,
  geoLocationHeader,
];

if (window.isDebugMode) middlewares.push(queryDebug);

const client = new ApolloClient({
  link: ApolloLink.from([onError(trackGraphQLErrors(ignoreList)), ...middlewares, httpLink]),
  cache: new InMemoryCache(),
  shouldBatch: true,
});

export default client;
